function cov_dib64bgbt() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Neighborhood.tsx";
  var hash = "99465bee0b629b499cdb1d70cd739c17812348bd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Neighborhood.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "99465bee0b629b499cdb1d70cd739c17812348bd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dib64bgbt = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_dib64bgbt();
var Icon = (cov_dib64bgbt().s[0]++, {
  name: 'neighborhood',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5 11.3016L12 9.55164L9.5 11.3016V14H14.5V11.3016ZM11.7133 6.70071C11.8854 6.5802 12.1146 6.5802 12.2867 6.70071L16.7867 9.85071C16.9204 9.94428 17 10.0972 17 10.2603V16C17 16.2761 16.7761 16.5 16.5 16.5H7.5C7.22386 16.5 7 16.2761 7 16V10.2603C7 10.0972 7.07961 9.94428 7.21327 9.85071L11.7133 6.70071Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.5 4.5V19.5H19.5V4.5H4.5ZM4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4Z\" fill=\"currentColor\"/>"
});
export default Icon;